import { ToggleSwitch } from "@/components";
import { RightWrapper } from "../../../components";
import { useState, useCallback, useMemo, useEffect } from "react";
import { useApi, useAlert } from "@/";
import { useSelector, useDispatch } from "react-redux";
import { addChannelSettings } from "../../../app/Slices";
const Channel = () => {
  const { callApi } = useApi();
  const { alert, AlertDialog } = useAlert();
  const dispatch = useDispatch();
  const channels = useSelector((state) => state.app.appData.channels) || [];
  

  const [channelList, setChannelList] = useState([]);

  useEffect(() => {
    if (Array.isArray(channels) && channels.length > 0) {
      setChannelList(
        channels.map((channel) => ({
          id: channel._id || `default_id_${channel.slug}`,
          name: channel.name,
          icon: channel.logoUrl || "default_logo.png", // Fallback if logoUrl is empty
          isActive: channel.isActive ?? false, // Directly getting isActive from API
        }))
      );
    }
  }, [channels]);
  const handleToggle = useCallback(
    async (channelId) => {
      // Find the channel and determine its new state
      const currentChannel = channelList.find(
        (channel) => channel.id === channelId
      );
      const newIsActive = !currentChannel.isActive;

      // Prepare payload with updated state
      const payload = {
        config: channelList.map((channel) => ({
          channelId: channel.id,
          isEnabled: channel.id === channelId ? newIsActive : channel.isActive,
        })),
      };

      try {
        // Optimistically update local state
        const updatedChannelList = channelList.map((channel) =>
          channel.id === channelId
            ? { ...channel, isActive: newIsActive }
            : channel
        );
        setChannelList(updatedChannelList);

        // Make API call
        const response = await callApi(
          "/admin/channelManagement",
          "PUT",
          payload
        );

        if (!response.success) {
          throw new Error(
            response.error?.message || "Failed to update channel settings."
          );
        }

        // Update Redux store
        dispatch(addChannelSettings(response.data));
        alert("Channel settings updated successfully!");
      } catch (error) {
        console.error(
          "Failed to update channel settings:",
          error.message || error
        );
        alert("Failed to update channel settings. Please try again later.");

        // Revert local state on error
        setChannelList((prevChannelList) =>
          prevChannelList.map((channel) =>
            channel.id === channelId
              ? { ...channel, isActive: !newIsActive }
              : channel
          )
        );
      }
    },
    [channelList, callApi, dispatch, alert]
  );
  const channelListCard = useMemo(
    () =>
      channelList.map((channel) => (
        <div
          key={channel.id}
          className="flex justify-between items-center w-full bg-background_2 p-4 rounded-xl gap-2"
        >
          {channel.icon ? (
            <img
              src={channel.icon}
              alt={channel.name}
              className="w-1/2 md:w-fit"
            />
          ) : (
            <span className="text-lg font-medium text-secondary">
              {channel.name}
            </span>
          )}
          <ToggleSwitch
            checked={channel.isActive}
            onClick={() => handleToggle(channel.id)}
          />
        </div>
      )),
    [channels, handleToggle]
  );

  return (
    <RightWrapper>
      <div className="flex flex-col gap-4 mt-2 px-2 relative pb-20 md:pb-4">
        <div className="flex flex-col gap-1 w-full">
          <h1 className="text-headline4 md:text-headline3 font-nunito text-secondary/95 font-semibold">
            Channel Management
          </h1>
          <p className="text-body2 font-ptsans text-secondary/60 lg:w-[50%]">
            Seamlessly connect and manage multiple sales channels for effortless
            order and inventory synchronization.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full mt-4">
          {channelListCard}
        </div>
      </div>
      <AlertDialog />
    </RightWrapper>
  );
};

export default Channel;
